export enum TypeContractEnum {
    ACTIVE = 'activeContract',
    TERMINATED = 'terminatedContract',
    PROTECTEDHOUSE = 'protectedHouseContract',
    MULTI = 'multiContract',
}
